import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next'
import Select from 'react-select';
import clsx from 'clsx';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'

const NotificationTypeOption = ({ innerRef, innerProps, ...rest }) => {
    const { data, isSelected } = rest;

    const styles = data.locked ? {
        pointerEvents: 'none',
        color: '#aaa'
    } : {}

    return (
        <div 
            className={clsx(
                'd-flex flex-column px-3 py-1 juridistion-select--option text-dark', 
                isSelected && 'active', 
                data.locked && 'disabled'
            )} 
            ref={innerRef} 
            style={styles}
            {...innerProps}
        >
            <div className="align-items-center">
                <img className="signature-icon" src={data.image} style={{width: 30}} alt={data.description} />
                <strong className="ml-2">{data.label}</strong>
            </div>
            <small>{data.description}</small>
            {/* <components.Option {...props} /> */}
        </div>
    );
}

export function useNotificationTypesList() {
    const { t } = useTranslation();

    const notificationTypesMap = useMemo(() => {
        return new Map([
            ['email', {
                label: t('editor.config.notification_email'),
                value: 'email',
                image: '/images/listing/email.png',
                description: t('editor.config.notification_email_description'),
            }],
            ['sms',  { 
                label: 'SMS', 
                value: 'sms', 
                image: '/images/listing/email.png',
                description: t('editor.config.notification_sms_description') 
            }],
            ['email-sms', { 
                label: 'Email & SMS', 
                value: 'email-sms', 
                image: '/images/listing/email.png',
                description: t('editor.config.notification_sms_email_description') 
            }],
        ])
    }, [t])
    
    return { notificationTypesMap, notificationTypesArray: Array.from(notificationTypesMap.values()) }
}

export function NotificationTypesSelect({ value, onChange, ...props }) {
    const [realValue, setRealValue] = useState(null);
    const { notificationTypesArray, notificationTypesMap } = useNotificationTypesList();

    useEffect(() => {
        if (notificationTypesMap.get(value)) {
            setRealValue(notificationTypesMap.get(value))
        } else {
            setRealValue(null)
        }
    }, [notificationTypesMap, value])

    const handleChange = (option) => {
        onChange(option?.value || null, option)
    }

    return <Select 
        components={{ Option: NotificationTypeOption }}
        options={notificationTypesArray}
        styles={reactSelectStyles}
        value={realValue}
        onChange={handleChange}
        {...props}
    />
}